'use client';

import TextHeader from '@/components/Desktop/TextHeader';
import { useContentSize } from '@/components/SizeProvider';
import { getChromeBarHeight } from '@/lib/utils/desktopGeometry';

const LINE_WIDTH_RATIO = 0.45;
const LINE_TITLE_CLEARANCE = 40;

export default function HeaderDesktop() {
  const { width: widthContent, height: heightContent } = useContentSize();
  const lineWidth = `${widthContent * LINE_WIDTH_RATIO - LINE_TITLE_CLEARANCE}px`;

  return (
    <header className='header-desktop-container'
      style={{
        height: getChromeBarHeight(heightContent),
      }}
    >
      <div className={'header-info-container'}
        style={{
          width: widthContent,
        }}
      >
        <div className="line-header"
          style={{
            width: lineWidth,
          }}
        />
        <TextHeader />
        <div className="line-header"
          style={{
            width: lineWidth,
          }}
        />
      </div>
    </header>
  )
}